export const PredictionMarketsPriceView = {
  Yes: 'yes',
  No: 'no',
  Both: 'both',
} as const;
export type PredictionMarketsPriceView = (typeof PredictionMarketsPriceView)[keyof typeof PredictionMarketsPriceView];

export interface PredictionMarketsPriceGridFilterState {
  categories?: string[];
  seriesNames?: string[];
  search?: string;
  market?: string;
  marketAccount?: string;
  priceView?: PredictionMarketsPriceView;
}
